export default __webpack_public_path__ + "static/media/recal-media-ueBIGLmiI5A-unsplash.53927eaf.jpg";